import { render, staticRenderFns } from "./NewPatientMobile.vue?vue&type=template&id=553ae19a&scoped=true&"
import script from "./NewPatientMobile.vue?vue&type=script&lang=js&"
export * from "./NewPatientMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewPatientMobile.vue?vue&type=style&index=0&id=553ae19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ae19a",
  null
  
)

export default component.exports